import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NoticeBoardService } from 'src/app/core/services/notice-board/notice-board.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
@Component({
    selector: 'app-admin-notice-popup',
    templateUrl: './admin-notice-popup.component.html',
    styleUrls: ['./admin-notice-popup.component.scss'],
})
export class AdminNoticePopupComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<AdminNoticePopupComponent>,
        private _noticeBoardService: NoticeBoardService,
        private _toasterService: ToasterService,
        private _loaderService: LoaderService,
        @Inject(MAT_DIALOG_DATA)
        public data
    ) {}

    ngOnInit(): void {
        // console.log("Modal");

        // console.log(this.data);
        // console.log(this.data.data.title);
    }

    customOptions: OwlOptions = {
        loop: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false,
        navSpeed: 700,
        navText: ['', ''],
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 2,
            },
            740: {
                items: 3,
            },
            940: {
                items: 4,
            },
        },
        nav: true,
    };

    dismissThisNotice() {
        this._loaderService.hideLoader();
        this._noticeBoardService
            .noticeSeenAdmin(this.data.data.id, { isRead: 'true' })
            .subscribe(
                (res) => {
                    this._loaderService.hideLoader();
                    this._toasterService.showSuccess(
                        'SUCCESS',
                        'Successfully read'
                    );
                    this.dialogRef.close('next');
                },
                (err) => {
                    this._toasterService.showError(
                        'Error',
                        'dismissThisNotice has error with "noticeSeenAdmin" API '
                    );
                    this._loaderService.hideLoader();
                }
            );
    }

    close() {
        this.dialogRef.close('next');
    }
}
